import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

export const LOCAL_STORAGE_ID = 'jsm-all-queues-state';
export const LOCAL_STORAGE_KEY = 'is-open';

export const getAllQueuesStateFromLocalStorage = (projectId: string): boolean | undefined => {
	const localStorageProvider = createLocalStorageProvider(LOCAL_STORAGE_ID);
	try {
		const result = localStorageProvider.get(`${LOCAL_STORAGE_KEY}-${projectId}`);
		return result;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		return undefined;
	}
};

export const setAllQueuesStateInLocalStorage = (projectId: string, value: boolean) => {
	const localStorageProvider = createLocalStorageProvider(LOCAL_STORAGE_ID);
	try {
		localStorageProvider.set(`${LOCAL_STORAGE_KEY}-${projectId}`, value);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (_: any) {
		// do nothing
	}
};
